import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Setting = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      fill={'none'}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      width={Sizes[size]}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
      <path
        d="M1.33337 8.58679V7.41345C1.33337 6.72012 1.90004 6.14679 2.60004 6.14679C3.80671 6.14679 4.30004 5.29345 3.69337 4.24679C3.34671 3.64679 3.55337 2.86679 4.16004 2.52012L5.31337 1.86012C5.84004 1.54679 6.52004 1.73345 6.83337 2.26012L6.90671 2.38679C7.50671 3.43345 8.49337 3.43345 9.10004 2.38679L9.17337 2.26012C9.48671 1.73345 10.1667 1.54679 10.6934 1.86012L11.8467 2.52012C12.4534 2.86679 12.66 3.64679 12.3134 4.24679C11.7067 5.29345 12.2 6.14679 13.4067 6.14679C14.1 6.14679 14.6734 6.71345 14.6734 7.41345V8.58679C14.6734 9.28012 14.1067 9.85345 13.4067 9.85345C12.2 9.85345 11.7067 10.7068 12.3134 11.7535C12.66 12.3601 12.4534 13.1335 11.8467 13.4801L10.6934 14.1401C10.1667 14.4535 9.48671 14.2668 9.17337 13.7401L9.10004 13.6135C8.50004 12.5668 7.51337 12.5668 6.90671 13.6135L6.83337 13.7401C6.52004 14.2668 5.84004 14.4535 5.31337 14.1401L4.16004 13.4801C3.55337 13.1335 3.34671 12.3535 3.69337 11.7535C4.30004 10.7068 3.80671 9.85345 2.60004 9.85345C1.90004 9.85345 1.33337 9.28012 1.33337 8.58679Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
    </svg>
  );
};

Setting.displayName = 'Setting';
